import { useCallback } from "react";
import { useGetPaymentList } from "src/modules/api/User/getPaymentList/useGetPaymentList";
import { PersonalCreditCardData } from "./personalCreditCardData";

export const useCreditCardList = () => {
  const { data: creditCardListData, mutate: mutateCreditCardList } =
    useGetPaymentList();
  const updateCreditCardList = useCallback(
    (updatedCardList?: PersonalCreditCardData, shouldRevalidate?: boolean) => {
      if (!creditCardListData) {
        return;
      }
      mutateCreditCardList(
        {
          result: {
            ...creditCardListData,
            ...updatedCardList,
          },
        },
        shouldRevalidate
      );
    },
    [creditCardListData, mutateCreditCardList]
  );

  return {
    creditCardListData,
    updateCreditCardList,
  };
};
